"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAssetFolderURLBase = void 0;
const Entities_1 = require("../../Entities");
class GetAssetFolderURLBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (!castPayload.callback) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'GET_APP_ASSET_URL';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { callback } = this.castPayloadV1(payload);
                this.action(callback);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.GetAssetFolderURLBase = GetAssetFolderURLBase;
